import useSegments from 'hooks/queries/useSegments';
import { CampaignSend } from '../../customCampaignReducer';
import useSegmentCohorts from 'hooks/queries/useSegmentCohorts';
import { useMemo } from 'react';
import { Cohort, Segment } from 'domains/segments/types';
import useFeatureSettings from 'hooks/queries/useFeatureSettings';

const useAudienceData = (send: CampaignSend) => {
    const { data: featureSettings } = useFeatureSettings();

    // Cohorts are only available when platform is integrated
    const isPlatformIntegrated = featureSettings?.platformIntegrated;
    const isCohortEnabled = isPlatformIntegrated && Boolean(send.cohortId);

    const { data: audiences } = useSegments({
        enabled: Boolean(send.segmentId),
    });

    const { data: cohorts } = useSegmentCohorts({
        reactQueryOptions: { enabled: isCohortEnabled },
    });

    const currentAudience = useMemo(() => {
        if (send.segmentId && audiences) {
            return audiences.find((audience: Segment) => audience.id === send.segmentId);
        }
        if (send.cohortId && cohorts?.data) {
            return cohorts.data.find((cohort: Cohort) => cohort.id === send.cohortId);
        }
        return null;
    }, [send.segmentId, send.cohortId, audiences, cohorts?.data]);

    return { currentAudience };
};

export default useAudienceData;
